import React from 'react';
import { connect } from '@gasbuddy/react';
import { FlexGrid } from '@gasbuddy/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

import MainLayout from '../../components/main-layout';
import PageHeader from '../../components/page-header';
import CTAContainer from '../../components/cta-container';
import SharePageButton from '../../components/share-page-button';
import StationSuggestedEditsTable from '../../components/station-suggested-edits-table';
import BPLink from '../../components/bp-link';

import styles from './styles.css';

/* eslint-disable react/prefer-stateless-function */
function StationSuggestedEdits() {
  return (
    <MainLayout>
      <FlexGrid>
        <FlexGrid.Column>
          <PageHeader title="Suggested Edits" />
          <CTAContainer alignment="right" style={{ paddingRight: '15px' }}>
            <SharePageButton gTagTitle="Station Suggested Edits - Share Report" />
          </CTAContainer>
        </FlexGrid.Column>
        <FlexGrid.Column>
          <BPLink to="/client/my-listings/suggested-edits">
            <div className={styles.allSuggestedEditsLink}>
              <FontAwesomeIcon icon={faAngleLeft} className={styles.faIcon} />
              <span>View all Suggested Edits</span>
            </div>
          </BPLink>
        </FlexGrid.Column>
        <FlexGrid.Column>
          <StationSuggestedEditsTable />
        </FlexGrid.Column>
      </FlexGrid>
    </MainLayout>
  );
}

export default connect()(StationSuggestedEdits);
